import { render } from "./PlanStats.vue?vue&type=template&id=dfbea5d8"
import script from "./PlanStats.vue?vue&type=script&lang=js"
export * from "./PlanStats.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__